import getRedirectUrl from './app'

getRedirectUrl().then((redirectUrl) => {
  if (redirectUrl) {
    document.location.href = redirectUrl
  }
})
